import { AbstractResponse } from './AbstractResponse';

export class ResponseCargo<T> extends AbstractResponse {
  public valid = true;

  constructor(public model: T) {
    super();
  }
}
